import { AgentCommon } from '~/agents/common/common/agent'

export const SalesAssistantAgentCommon: AgentCommon = {
  key: 'salesAssistant',
  hasOnboarding: true,
  hasSettings: true,
  guidelines: [
    {
      label: 'Cold Email Writing Style',
      tag: 'cold_email_template',
      suggestions: [
        `Start with a compelling hook to grab attention`,
        `Keep messages concise and clear`,
        `Include a clear call-to-action`,
        `Include a question`,
        `Use emojis to convey tone and emotion`,
        `Utilize storytelling to convey a more personal approach`,
        `Highlight benefits over features`,
        `Use bullet points or numbered lists for readability`,
        `Avoid jargon; keep language accessible`,
      ],
    },
    {
      label: 'Direct Message Writing Style',
      tag: 'direct_message_template',
      suggestions: [
        `Start with a compelling hook to grab attention`,
        `Keep messages concise and clear`,
        `Include a clear call-to-action`,
        `Include a question`,
        `Use emojis to convey tone and emotion`,
        `Utilize storytelling to convey a more personal approach`,
        `Highlight benefits over features`,
        `Use bullet points or numbered lists for readability`,
        `Avoid jargon; keep language accessible`,
      ],
    },
  ],
}
